/**
 * Checks if a value is null or undefined.
 *
 * Note that this is a type guard that narrows the type.
 *
 * @param {unknown} value - value to check
 * @returns {value is null | undefined} - true if value is null or undefined
 */
export default function isNullOrUndef(value) {
  return value === null || value === undefined;
}
